export class VoucherCategory {
  voucherCategoryId!: number
  name!: string
  nameEn: string = ''
  description: string = ''
  imageUrl!: string
}
